// Phase 1C FINAL — production selection coordinator.
//
// One monotonic `generation` counter guards every user selection action.
// GridViewer bumps the generation via `begin()` BEFORE any early return
// (outside grid, tile-not-loaded, conflict, parcel, empty). Every async
// completion (cell request, detail request) carries the `token` it was
// started at and calls `isCurrent(token)` to decide whether to publish.
//
// This makes cell/detail/outside/loading-map/conflict selections all use
// the SAME invariant: a later user action always invalidates every earlier
// pending async result, regardless of kind.
export class SelectionCoordinator {
  private gen = 0;

  /**
   * Bump the generation and return the new token. Every user selection
   * action MUST call this BEFORE any early return.
   */
  begin(): number {
    this.gen += 1;
    return this.gen;
  }

  /** True iff `token` is still the current generation. */
  isCurrent(token: number): boolean {
    return token === this.gen;
  }

  /** Read-only accessor for tests. */
  get current(): number {
    return this.gen;
  }
}
